import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import Select, { createFilter } from 'react-select';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';

import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as actions from '../action';
import * as c from '../constant';

function PartnerModal({
  createInput,
  createUserManagement,
  setFormData,
  formData,
  getSettings,
  history,
  showUserManagement,
  getRoleList,
  creating,
}) {
  const setModal = useContext(ModalContext);

  const handleOnSubmit = (e) => {
    e.preventDefault();
    createUserManagement(formData, ({ data }) => {
      setModal({ isOpen: false });
      getSettings();
      history.push(`/general-settings/brgy-chairmen/${_.get(data, 'id')}`);
      showUserManagement(data.id);
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    getRoleList();
  }, []);

  const createOpts = () => {
    const barangayArr = [];
    const zoneArr = [];
    for (let i = 1; i <= 905; i += 1) {
      barangayArr.push({ label: `Barangay ${i}`, value: i });
    }
    for (let x = 1; x <= 100; x += 1) {
      zoneArr.push({ label: `Zone ${x}`, value: x });
    }
    return { barangay: barangayArr, zone: zoneArr };
  };

  const opts = createOpts();

  const handleChangeSelect = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="form-group col-12">
            <label htmlFor="zone" className="full-label mb-0">
              District No.
            </label>
            <Select
              filterOption={createFilter({
                ignoreAccents: false,
              })}
              name="district_number"
              placeholder="Select Module Type"
              onChange={handleChangeSelect('district_number')}
              options={c.DISTRICTS}
              value={
                _.get(formData, 'district_number')
                  ? {
                      value: _.get(formData, 'district_number'),
                      label: _.get(formData, 'district_number'),
                    }
                  : { value: '', label: 'Please Select a district number' }
              }
            />
          </div>
        </div>
        <div className="row">
          <div className="form-group col-12">
            <label htmlFor="zone" className="full-label mb-0">
              Zone No.
            </label>
            <Select
              filterOption={createFilter({
                ignoreAccents: false,
              })}
              name="zone_number"
              placeholder="Select Module Type"
              onChange={handleChangeSelect('zone_number')}
              options={opts.zone}
              value={
                _.get(formData, 'zone_number')
                  ? {
                      value: _.get(formData, 'zone_number'),
                      label: _.get(formData, 'zone_number'),
                    }
                  : { value: '', label: 'Please Select a zone number' }
              }
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12 form-group">
            <label>Barangay Number</label>
            <Select
              filterOption={createFilter({
                ignoreAccents: false,
              })}
              name="barangay_number"
              placeholder="Select Module Type"
              onChange={handleChangeSelect('barangay_number')}
              options={opts.barangay}
              value={
                _.get(formData, 'barangay_number')
                  ? {
                      value: _.get(formData, 'barangay_number'),
                      label: _.get(formData, 'barangay_number'),
                    }
                  : { value: '', label: 'Please Select a barangay number' }
              }
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12 form-group">
            {createInput(
              { key: 'name', label: 'Barangay Chairman Name' },
              { required: true, placeholder: 'Input Barangay Chairman Name' }
            )}
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={creating}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {creating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={creating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

PartnerModal.propTypes = {
  createInput: PropTypes.instanceOf(Function).isRequired,
  getSettings: PropTypes.instanceOf(Function).isRequired,
  createUserManagement: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  showUserManagement: PropTypes.instanceOf(Function).isRequired,
  getRoleList: PropTypes.instanceOf(Function).isRequired,
  creating: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  roleList: _.get(api, `${c.GET_ROLE_LIST}.list`) || [],
  creating: api.loading.indexOf(c.CREATE_SETTING) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(PartnerModal);
